import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { FAQService } from 'app/core/faq/faq.service';
import { InitialData } from './faq-video.types';

@Injectable({
    providedIn: 'root'
})
export class FaqVideoDataResolver implements Resolve<any>
{
    /**
     * Constructor
     */
    constructor(private _httpClient: HttpClient, private _faqService: FAQService) {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<InitialData> {
        return this._faqService.getVideos()
            .pipe(
                map((videos) => ({
                    videos
                })
                ),
                catchError(err => {
                    this._faqService.errorMessage = err.error.message ? err.error.message : "Something went wrong !";
                    return of(new DefaultResponse().videos);
                })
            );
    }

}
class DefaultResponse implements InitialData {
    videos: any = [];
}